<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title is-5">{{ getTitleFranchisee }}</h1>
          </div>
        </div>
        <router-link
          slot="right"
          :to="{ name: 'Franchisee' }"
          class="button is-small is-link"
          >Back to list</router-link
        >
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <form
        autocomplete="off"
        @submit.prevent="onSubmit"
        enctype="multipart/form-data"
        name="saveFranchisee"
      >
        <div>
          <card-component>
            <v-col cols="12" lg="4">
              <v-row no-gutters>
                <v-col cols="12" class="my-0 py-0 text-center body-1 mb-5">
                  Profile Picture *
                </v-col>

                <v-col cols="6" class="d-flex justify-center">
                  <div @click="launchFilePicker()">
                    <div slot="activator">
                      <v-avatar
                        style="border: 5px solid #e5e5e5"
                        elevation="10"
                        size="150px"
                        v-ripple
                        v-if="!imageURL"
                        class="grey lighten-3 mb-3"
                      >
                        <span>Click to add Profile Image</span>
                      </v-avatar>
                      <v-avatar
                        style="border: 5px solid #e5e5e5"
                        elevation="10"
                        size="150px"
                        v-ripple
                        v-else
                        class="mb-3"
                      >
                        <img :src="imageURL" alt="avatar" />
                      </v-avatar>
                    </div>
                  </div>
                  <input
                    accept=".jpg, .png, .jpeg"
                    type="file"
                    ref="file"
                    @change="
                      onFileChange($event.target.name, $event.target.files)
                    "
                    style="display: none"
                  />
                </v-col>
                <v-col
                  cols="6"
                  class="d-flex justify-center"
                  v-if="franchiseeObj.franchiseeLogo"
                >
                  <div
                    @click="removeImage()"
                    color="primary"
                    class="ma-2"
                    close
                    @click:close="removeImage()"
                  >
                    <img
                      :src="franchiseeLogoUrl"
                      width="150px"
                      height="150px"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label">
                    Franchisee Name
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      required
                      title="Enter Valid Franchisee Name !"
                      v-model.trim="franchiseeObj.companyName"
                      maxlength="50"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">
                    Region/Zone
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <div class="control select is-fullwidth">
                      <select required v-model.trim="franchiseeObj.region" @change="onRegionChange">
                        <option value>---select---</option>
                        <option
                          v-for="region in regionArr"
                          v-bind:key="region.name"
                          v-bind:value="region.name"
                        >
                          {{ region.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">
                    Sub-Region
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <div class="control select is-fullwidth">
                      <select required v-model.trim="franchiseeObj.subRegion">
                        <option value>---select---</option>
                        <option
                          v-for="region in subRegionArr"
                          v-bind:key="region.name"
                          v-bind:value="region.name"
                        >
                        {{ region.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label"> B2B Code </label>
                  <div class="control">
                    <input
                      class="input"
                      pattern="^[a-zA-Z0-9]*$"
                      onKeyPress="if(this.value.length==15) return false;"
                      type="number"
                      title="Enter the Branch Code !"
                      v-model.trim="franchiseeObj.b2bID"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">
                    Academic Year
                    <span class="requir">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <select
                      required
                      v-model.trim="franchiseeObj.academicYearID"
                    >
                      <option value>---Select---</option>
                      <option
                        v-for="yr in academicYrs"
                        v-bind:key="yr.id"
                        v-bind:value="yr.id"
                      >
                        {{ yr.academicYear }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column is-6">
                <div class="field">
                  <label class="label">
                    Email address
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      autocomplete="new-email"
                      class="input"
                      required
                      type="email"
                      name="email"
                      v-model="franchiseeObj.email"
                      maxlength="100"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$"
                      title="Enter Valid Email id"
                      :disabled="disabled"
                    />
                  </div>
                </div>
              </div>

              <div class="column is-3" v-if="!franchiseeId">
                <div class="field">
                  <label class="label">
                    Password
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      class="input"
                      pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&.^#_])[A-Za-z\d$@$!%*?&.^#_]{8,40}$"
                      title="Enter Valid password."
                      autocomplete="new-password"
                      required
                      type="password"
                      name="password"
                      v-model="franchiseeObj.password"
                      maxlength="20"
                    />
                  </div>
                </div>
              </div>

              <div class="column is-6 mr-1">
                <div class="control" style="display: flex; align-items: center;">
                  <v-checkbox
                    v-model="franchiseeObj.isHeavyWinter"
                    label="HW applicable"
                    class="mr-3 label"
                  />
                </div>
              </div>

            </div>
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label">
                    Mobile number
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      class="input"
                      required
                      onKeyPress="if(this.value.length==10) return false;"
                      v-model.trim="franchiseeObj.mobileno"
                      maxlength="10"
                      type="number"
                      pattern="^[6-9]\d{9}$"
                      title="Enter Valid 10 digit Mobile Number"
                    />
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">
                    Business Partner Contact No
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      class="input"
                      required
                      onKeyPress="if(this.value.length==10) return false;"
                      v-model.trim="franchiseeObj.businessPartnerMobileno"
                      maxlength="10"
                      type="number"
                      pattern="^[6-9]\d{9}$"
                      title="Enter Valid 10 digit Business Partner Contact No."
                      @keypress="validateNumberInput"
                    />
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">
                    GST Type
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <div class="control select is-fullwidth">
                      <select
                        required
                        v-model.trim="franchiseeObj.gstType"
                        @change="getGSTtype()"
                      >
                        <option value>---select---</option>
                        <option
                          v-for="gst in this.gstTypeArr"
                          v-bind:key="gst.name"
                          v-bind:value="gst.name"
                        >
                          {{ gst.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column" v-if="this.enableGST">
                <div class="field">
                  <label class="label">
                    GST NO
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      type="text"
                      :readonly="checkreadonly"
                      class="input"
                      v-model="franchiseeObj.gstNo"
                      maxlength="16"
                      value
                      placeholder="Enter GST no"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label">
                    Center Type
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <div class="control select is-fullwidth">
                      <select required v-model.trim="franchiseeObj.modelID">
                        <option value>---select---</option>
                        <option
                          v-for="r in this.modelArr"
                          v-bind:key="r.id"
                          v-bind:value="r.id"
                        >
                          {{ r.title }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">
                    Franchisee Type
                    <span class="requir">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <select required v-model.trim="franchiseeObj.type">
                      <option value>---Select---</option>
                      <option
                        v-for="type in typeArr"
                        v-bind:key="type.name"
                        v-bind:value="type.name"
                      >
                        {{ type.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column">
                <!-- <div class="field">
                  <label class="label">
                    Advisory Fee (%)
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <div class="control">
                      <input class="input" type="number" required v-model.trim="franchiseeObj.advisoryFeePercentage" min="0" max="99" step="0.01" />
                    </div>
                  </div>
                </div> -->
                <div class="field">
                  <label class="label"> Tan No </label>
                  <div class="control">
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model.trim="franchiseeObj.tanNo"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">
                    Account No
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      class="input"
                      pattern="^[a-zA-Z0-9]*$"
                      onKeyPress="if(this.value.length==15) return false;"
                      type="text"
                      required
                      v-model.trim="franchiseeObj.accountNumber"
                      title="Enter Valid Account Number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="columns form-row">
              <div class="column is-6">
                <div class="field">
                  <label class="label">
                    Address
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <textarea
                      v-model.trim="franchiseeObj.address1"
                      type="text"
                      class="textarea is-small"
                      maxlength="300"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="column is-6">
                <div class="field">
                  <label class="label">
                    Pincode
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      class="input"
                      required
                      pattern="/^-?\d+\.?\d*$/"
                      onKeyPress="if(this.value.length==6) return false;"
                      title="Enter Valid PinCode"
                      type="number"
                      v-model.trim="franchiseeObj.pincode"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label">
                    State
                    <span class="requir">*</span>
                  </label>
                  <div class="control is-fullwidth">
                    <v-autocomplete
                      placeholder="--Select State--"
                      v-model="franchiseeObj.state"
                      :items="states"
                      @input="onStateChange()"
                      item-text="state"
                      item-value="state"
                      return-object
                      dense
                      outlined
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">
                    City
                    <span class="requir">*</span>
                  </label>
                  <div class="control is-fullwidth">
                    <v-autocomplete
                      placeholder="--Select City--"
                      v-model="franchiseeObj.city"
                      :items="cityList"
                      item-text="cityName"
                      item-value="cityName"
                      dense
                      outlined
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label">
                    Academic Year Start Date
                    <span class="requir">*</span>
                  </label>
                  <custom-date-picker prepend-icon="mdi-calendar" v-model="franchiseeObj.academicStartDate" required />
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">
                    Academic Year End Date
                    <span class="requir">*</span>
                  </label>
                  <custom-date-picker prepend-icon="mdi-calendar" :minToDate="franchiseeObj.academicStartDate"
                  v-model="franchiseeObj.academicEndDate" required />
                </div>
              </div>
            </div>
            <hr />
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label">
                    First Name
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      type="text"
                      pattern="[a-zA-Z\s]+"
                      title="Enter valid First Name !"
                      class="input"
                      required
                      v-model="franchiseeObj.firstname"
                      maxlength="100"
                    />
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field">
                  <label class="label">
                    Last Name
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      class="input"
                      pattern="[a-zA-Z\s]+"
                      title="Enter valid Last Name !"
                      required
                      type="text"
                      v-model="franchiseeObj.lastname"
                      maxlength="100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column is-6">
                <div class="field">
                  <label class="label">
                    Trust Name
                    <span class="requir">*</span>
                  </label>
                  <div class="control">
                    <input
                      type="text"
                      title="Enter valid Trust Name !"
                      class="input"
                      required
                      v-model="franchiseeObj.trustName"
                      maxlength="100"
                    />
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label"> Razorpay Account ID </label>
                  <div class="control">
                    <input
                      type="text"
                      title="Enter Razorpay Account ID!"
                      class="input"
                      v-model="franchiseeObj.razorPayAccountID"
                      maxlength="50"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns form-row">
              <div class="column is-6">
                <div class="field">
                  <label class="label"> Google Map URL </label>
                  <div class="control">
                    <input
                      type="url"
                      title="Google Map URL"
                      class="input"
                      v-model="franchiseeObj.googleMapsURL"
                    />
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label"> Centre Page URL </label>
                  <div class="control">
                    <input
                      type="url"
                      title="Centre Page URL"
                      class="input"
                      v-model="franchiseeObj.centrePageURL"
                    />
                  </div>
                </div>
              </div>
            </div>
            <footer class="column has-text-right">
              <button class="button is-success" type="submit">Save</button>
            </footer>
          </card-component>
        </div>
      </form>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import CustomDatePicker from '@/components/template/CustomDatePickerr'
import moment from 'moment'

const today = new Date()

export default {
  components: {
    CardComponent,
    CustomDatePicker
  },
  name: 'SaveFranchisee',
  props: ['franchiseeId', 'title'],
  data () {
    return {
      fromDate: moment().format('DD-MMM-YYYY'),
      toDate: moment().format('DD-MMM-YYYY'),
      imageFile: null,
      imageURL: null,
      disabled: false,
      wrongPincode: false,
      getTitleFranchisee: 'Add Franchisee',
      data: [],
      city: true,
      states: [],
      cityList: [],
      loadingComponent: null,
      franchiseeLogoUrl: '',
      franchiseeObj: {
        email: '',
        mobileno: '',
        address1: '',
        city: '',
        state: '',
        b2bID: '',
        firstname: '',
        lastname: '',
        companyName: '',
        gstNo: '',
        modelID: '',
        type: '',
        advisoryFeePercentage: '',
        tanNo: null,
        accountNumber: '',
        password: '',
        academicYearID: '',
        gstType: '',
        pincode: '',
        trustName: '',
        subRegion: '',
        razorPayAccountID: '',
        region: '',
        googleMapsURL: '',
        centrePageURL: '',
        businessPartnerMobileno: '',
        academicStartDate: '',
        academicEndDate: '',
        isHeavyWinter: false
      },
      checkreadonly: false,
      enableGST: false,
      tempGSTno: '',
      stateArr: [],
      modelArr: [],
      typeArr: [{ name: 'FOFO' }, { name: 'COCO' }],
      gstTypeArr: [{ name: 'URP' }, { name: 'RD' }],
      regionArr: [
        { name: 'East' },
        { name: 'West' },
        { name: 'South' },
        { name: 'North' }
      ],
      hasClicked: false,
      loader: true,
      getTitle: '',
      error: null,
      date: new Date(),
      minDate: new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() - 5
      ),
      maxDate: new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 5
      ),
      academicYrs: [],
      changedEmail: null,
      subRegionArr: []
    }
  },

  async created () {
    await this.getStates()
    await this.getModelID()
    await this.getAcademicYrs()
    if (this.franchiseeId) {
      this.getTitleFranchisee = 'Edit Franchisee'
      this.getFranchiseeDetails(this.franchiseeId)

      this.disabled = true
    } else {
      this.getTitleFranchisee = 'Add Franchisee'
    }
  },
  watch: {
    userName (newValue) {
      this.form.name = newValue
    },
    userEmail (newValue) {
      this.form.email = newValue
    }
  },
  methods: {
    async onRegionChange () {
      try {
        if (this.franchiseeObj.region) {
          this.franchiseeObj.subRegion = null
          const { data } = await http.post(
            `${constants.API_URL}/api/franchisee/get/zone-wise-subregion`,
            {
              zone: [this.franchiseeObj.region]
            }
          )
          this.subRegionArr = data || []
        } else {
          this.subRegionArr = []
          this.franchiseeObj.subRegion = null
        }
      } catch (e) {
        this.subRegionArr = []
        this.franchiseeObj.subRegion = null
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    validateNumberInput (event) {
      const char = String.fromCharCode(event.keyCode)
      if (!/^\d$/.test(char)) {
        event.preventDefault()
      }
    },
    getStates: async function () {
      try {
        const stateresponse = await http.get(
          `${constants.API_URL}/api/cityandstate/state`
        )
        this.states = stateresponse.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    onStateChange: async function () {
      try {
        const cityResp = await http.get(
          `${constants.API_URL}/api/cityandstate/city-list/${this.franchiseeObj.state.id}`
        )
        this.cityList = cityResp.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    launchFilePicker () {
      console.log('this.$refs.file.click()--', this.$refs.file)
      this.$refs.file.click()
    },
    onFileChange (fieldName, file) {
      console.log('fieldName, file', fieldName, file)
      const { maxSize } = this
      let imageFile = file[0]

      // check if user actually selected a file
      if (file.length > 0) {
        let size = imageFile.size / maxSize / maxSize
        if (!imageFile.type.match('image.*')) {
          // check whether the upload is an image
          this.errorDialog = true
          this.errorText = 'Please choose an image file'
        } else if (size > 1) {
          // check whether the size is greater than the size limit
          this.errorDialog = true
          this.errorText =
            'Your file is too big! Please select an image under 1MB'
        } else {
          // Append file into FormData & turn file into image URL
          this.imageFile = imageFile
          this.imageURL = URL.createObjectURL(imageFile)
        }
      }
    },
    removeImage () {
      if (confirm('Do you really want to remove this franchisee logo?')) {
        this.franchiseeLogoUrl = this.franchiseeLogo = ''
      } else {
        return false
      }
    },
    getS3Url: async function (key) {
      try {
        let response = await http.get(
          `${constants.API_URL}/api/ticket/downloadurl?s3urlKey=${key}`
        )
        return response.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return errorMessage
      }
    },
    getFranchiseeDetails: async function (franchiseeId) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(
          `${constants.API_URL}/api/franchisee/${franchiseeId}`
        )
        this.franchiseeObj = { ...response.data }
        if (response.data.region) {
          this.franchiseeObj.region = response.data.region
          await this.onRegionChange()
          if (this.subRegionArr.length > 0) {
            let subRegionFromAPI = response.data.subRegion
            let subRegionExists = this.subRegionArr.some(
              sr => sr.name === subRegionFromAPI
            )
            if (subRegionExists) {
              this.franchiseeObj.subRegion = subRegionFromAPI
            } else {
              this.franchiseeObj.subRegion = null
            }
          } else {
            this.franchiseeObj.subRegion = null
          }
        }
        this.states.forEach((item) => {
          if (item.state === this.franchiseeObj.state) {
            this.franchiseeObj.state = item
          }
        })
        await this.onStateChange()
        this.franchiseeObj.gstType =
          this.franchiseeObj.gstNo === 'URP' ? 'URP' : 'RD'
        this.tempGSTno = this.franchiseeObj.gstNo
        this.enableGST = true
        if (this.franchiseeObj.franchiseeLogo) {
          this.franchiseeLogoUrl = await this.getS3Url(
            this.franchiseeObj.franchiseeLogo
          )
        }
        if (this.franchiseeObj.gstNo === 'URP') {
          this.checkreadonly = true
        }
        if (this.franchiseeObj.googleMapsURL === 'null') {
          this.franchiseeObj.googleMapsURL = ''
        }
        if (this.franchiseeObj.centrePageURL === 'null') {
          this.franchiseeObj.centrePageURL = ''
        }
        this.franchiseeObj.academicStartDate = this.franchiseeObj.academicStartDate
          ? moment(this.franchiseeObj.academicStartDate).format('YYYY-MM-DD')
          : null

        this.franchiseeObj.academicEndDate = this.franchiseeObj.academicEndDate
          ? moment(this.franchiseeObj.academicEndDate).format('YYYY-MM-DD')
          : null
        this.loadingComponent.close()
        // this.getStateCityDetails(this.franchiseeObj.pincode)
        return this.franchiseeObj
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getStateCityDetails: async function (pincode) {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/city-by-pincode/${this.franchiseeObj.pincode}`
        )
        this.franchiseeObj.pincode = response.data.pincode
        // this.franchiseeObj.state = response.data.state_name
        // this.franchiseeObj.city = response.data.city[0]
        // console.log(this.franchiseeObj.state, 'diff')
        // this.data = response.data
        this.wrongPincode = false
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)
        this.lock = false
        this.wrongPincode = true
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: 'Invalid PinCode !',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    getModelID: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchisee/model`
        )
        this.modelArr = response.data.rows
        return this.modelArr
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching models', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getAcademicYrs: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYrs = response.data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching academic yrs', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    async onSubmit (event) {
      // if (!this.wrongPincode) {
      // await this.getStateCityDetails(this.franchiseeObj.pincode)
      // if (this.franchiseeObj.pincode.length !== 6) {
      //   return this.$dialog.error({
      //     text: 'Please Enter Valid pincode',
      //     title: 'Error'
      //   })
      // }
      if (this.franchiseeObj.mobileno.length < 10) {
        return this.$dialog.error({
          text: 'Please Enter Valid Mobile Number',
          title: 'Error'
        })
      }

      if (this.franchiseeObj.businessPartnerMobileno.length < 10 || this.franchiseeObj.businessPartnerMobileno.length > 11) {
        return this.$dialog.error({
          text: 'Please Enter Valid Business Partner Mobile Number',
          title: 'Error'
        })
      }
      if (this.franchiseeObj.mobileno === this.franchiseeObj.businessPartnerMobileno) {
        return this.$dialog.error({
          text: 'Please add alternate mobile no. as both the numbers cannot be same.',
          title: 'Error'
        })
      }

      if (
        this.franchiseeObj.accountNumber.length < 9 ||
        this.franchiseeObj.accountNumber.length > 18
      ) {
        return this.$dialog.error({
          text: 'Please Enter Valid Account Number',
          title: 'Error'
        })
      }

      if (
        this.franchiseeObj.gstNo.length !== 15 &&
        this.franchiseeObj.gstNo !== 'URP'
      ) {
        return this.$dialog.error({
          text: 'Please Enter Valid GST Number',
          title: 'Error'
        })
      }
      if (this.franchiseeObj.state === 'undefined' || this.franchiseeObj.state === undefined) {
        return this.$dialog.error({
          text: 'Please Select valid State',
          title: 'Error'
        })
      }
      if (this.franchiseeObj.city === 'undefined' || this.franchiseeObj.city === undefined) {
        return this.$dialog.error({
          text: 'Please Select valid City',
          title: 'Error'
        })
      }
      if (!this.franchiseeObj.academicStartDate) {
        return this.$dialog.error({
          text: 'Please Select Academic Start date',
          title: 'Error'
        })
      }
      if (!this.franchiseeObj.academicEndDate) {
        return this.$dialog.error({
          text: 'Please Select Academic End date',
          title: 'Error'
        })
      }
      this.changedEmail = this.franchiseeObj.email.toLowerCase()
      this.hasClicked = true
      this.loader = true
      const inputData = {
        isHeavyWinter: this.franchiseeObj.isHeavyWinter,
        companyName: this.franchiseeObj.companyName,
        email: this.changedEmail,
        address1: this.franchiseeObj.address1,
        state: this.franchiseeObj.state.state,
        city: this.franchiseeObj.city.toString(),
        pincode: this.franchiseeObj.pincode,
        gstNo: this.franchiseeObj.gstNo,
        mobileno: this.franchiseeObj.mobileno,
        firstname: this.franchiseeObj.firstname,
        lastname: this.franchiseeObj.lastname,
        modelID: this.franchiseeObj.modelID,
        type: this.franchiseeObj.type,
        accountNumber: this.franchiseeObj.accountNumber,
        // advisoryFeePercentage: this.franchiseeObj.advisoryFeePercentage,
        password: this.franchiseeObj.password
          ? this.franchiseeObj.password
          : '',
        academicYearID: this.franchiseeObj.academicYearID,
        trustName: this.franchiseeObj.trustName,
        region: this.franchiseeObj.region,
        subRegion: this.franchiseeObj.subRegion,
        franchiseeLogo: this.imageFile ? this.imageFile : '',
        b2bID: this.franchiseeObj.b2bID ? this.franchiseeObj.b2bID : '',
        razorPayAccountID: this.franchiseeObj.razorPayAccountID
          ? this.franchiseeObj.razorPayAccountID
          : '',
        googleMapsURL: this.franchiseeObj.googleMapsURL,
        centrePageURL: this.franchiseeObj.centrePageURL,
        businessPartnerMobileno: this.franchiseeObj.businessPartnerMobileno,

        academicStartDate: this.franchiseeObj.academicStartDate,
        academicEndDate: this.franchiseeObj.academicEndDate }

      if (this.franchiseeObj.tanNo) {
        let reg = new RegExp(/^[A-Za-z]{4}[0-9]{5}[A-Za-z]{1}$/)

        if (!this.franchiseeObj.tanNo.match(reg)) {
          return this.$dialog.error({
            text: 'Please provide Valid TAN Number',
            title: 'Error'
          })
        }
        inputData.tanNo = this.franchiseeObj.tanNo
      }
      // console.log('inputData--->', inputData)

      const formData = new FormData()

      for (var key in inputData) {
        formData.append(key, inputData[key])
      }

      if (this.franchiseeId) {
        /* Edit Franchisee Record */

        try {
          await http.put(
            `${constants.API_URL}/api/franchisee/${this.franchiseeId}`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )

          this.$router.push({ name: 'Franchisee' })
          return this.$buefy.dialog.alert({
            type: 'is-success',
            message: 'Franchisee Saved successfully!',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          console.log('Error While Saving Franchisee', errorMessage)
          this.lock = false
          this.hasClicked = false
          return this.$buefy.dialog.alert({
            message: errorMessage,
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } else {
        /* Add Franchisee */
        try {
          await http.post(`${constants.API_URL}/api/franchisee`, formData)
          this.loader = false
          this.$router.push({ name: 'Franchisee' })
          return this.$buefy.dialog.alert({
            type: 'is-success',
            message: 'Franchisee Saved successfully!',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          console.log('Error While Saving Franchisee', errorMessage)
          this.lock = false
          this.hasClicked = false
          return this.$buefy.dialog.alert({
            message: errorMessage,
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      }
      // } else {
      //   return this.$buefy.dialog.alert({
      //     message: 'Invalid PinCode !',
      //     type: 'is-danger',
      //     hasIcon: true,
      //     animation: 'zoom-out',
      //     size: 'is-medium',

      //     icon: ' mdi-exclamation',
      //     iconPack: 'mdi',
      //     ariaRole: 'alertdialog',
      //     ariaModal: true
      //   })
      // }
    },
    getGSTtype: function () {
      if (this.franchiseeObj.gstType === 'URP') {
        this.franchiseeObj.gstNo = 'URP'
        this.checkreadonly = true
        this.enableGST = true
      } else if (this.franchiseeObj.gstType === 'RD') {
        this.checkreadonly = false
        if (this.franchiseeId) {
          this.franchiseeObj.gstNo =
            this.tempGSTno === 'URP' ? '' : this.tempGSTno
        } else {
          this.franchiseeObj.gstNo = ''
        }

        this.enableGST = true
      } else {
        this.franchiseeObj.gstNo = ''
        this.checkreadonly = true
        this.enableGST = false
      }
    }
  }
}
</script>
